import { render, staticRenderFns } from "./RightArrowIcon.vue?vue&type=template&id=135adbb3&"
import script from "./RightArrowIcon.vue?vue&type=script&lang=js&"
export * from "./RightArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports